import apiService from './apiService';

// Detect device and platform
export const getDeviceInfo = () => {
  if (typeof window === 'undefined') return null;
  
  const userAgent = navigator.userAgent;
  
  // Detect mobile devices
  if (/Android/i.test(userAgent)) {
    return 'Android Device';
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'iOS Device';
  } else if (/Windows Phone/i.test(userAgent)) {
    return 'Windows Phone';
  } else if (/BlackBerry/i.test(userAgent)) {
    return 'BlackBerry';
  }
  
  // Desktop devices
  if (/Windows/i.test(userAgent)) {
    return 'Windows Desktop';
  } else if (/Mac/i.test(userAgent)) {
    return 'Mac Desktop';
  } else if (/Linux/i.test(userAgent)) {
    return 'Linux Desktop';
  }
  
  return 'Unknown Device';
};

export const getPlatformInfo = () => {
  if (typeof window === 'undefined') return null;
  
  const userAgent = navigator.userAgent;
  
  if (/Android/i.test(userAgent)) {
    return 'android';
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'ios';
  } else if (/Windows/i.test(userAgent)) {
    return 'windows';
  } else if (/Mac/i.test(userAgent)) {
    return 'macos';
  } else if (/Linux/i.test(userAgent)) {
    return 'linux';
  }
  
  return 'web';
};

// Register FCM token with backend
export const registerFCMTokenWithBackend = async (fcmToken) => {
  try {
    const device = getDeviceInfo();
    const platform = getPlatformInfo();
    
    await apiService.registerFCMToken(fcmToken, device, platform);
    return true;
  } catch (error) {
    console.error('Failed to register FCM token with backend:', error);
    return false;
  }
};

// Get FCM token from localStorage
export const getFCMToken = () => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('fcmToken');
};

// Store FCM token in localStorage
export const storeFCMToken = (token) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem('fcmToken', token);
};

// Remove FCM token from localStorage
export const removeFCMToken = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('fcmToken');
};

// Prepare login/register payload with FCM token
export const prepareAuthPayload = (credentials) => {
  const fcmToken = getFCMToken();
  const device = getDeviceInfo();
  const platform = getPlatformInfo();
  
  return {
    ...credentials,
    ...(fcmToken && { fcmToken }),
    ...(device && { device }),
    ...(platform && { platform })
  };
}; 